import React, {useEffect} from 'react';
import Frame from "../components/layout/Frame";
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import FacilityStatus from "./subPages/FacilityStatus";
import FailurePerformance from "./subPages/FailurePerformance";
import DisabilityStatus from "./subPages/DisabilityStatus";
import CMFWInfoBox from "../components/searchBoxs/CMFWInfoBox";
import FcltyFloorCtl from "../components/control/FcltyFloorCtl";
import PopUp from "../components/popUp/PopUp";

const DashFclty = ({propAuthInfo}) => {
  useEffect(() => {
    console.log(propAuthInfo)
  }, [])

  return (
      <Frame
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <Container fluid>
          <Row className={"p-4 h-100"}>
            <Col md={12}>
                  {/* 시설 현황 */}
              <div className={'layer p-2'}>
                <CMFWInfoBox
                    propFcltyID={propAuthInfo}
                    propIsReadOnly={true}
                />
                <FcltyFloorCtl
                    propFcltyID={propAuthInfo}
                    propIsReadOnly={true}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Frame>
  );
};

export default DashFclty;
